export default "__VITE_ASSET__DR0mSDF1__"